import dayjsTZ from "../../../../utils/dayjs";
import {
  buildReportResult,
  emptyReportResult,
  employeeFullName,
  intervalBounds,
} from "../reportResult";

const LEAVE_TYPES = ["Pushime", "Leje Ditore", "Dite Personale", "Sëmurë", "Leje Lindje"];

/**
 * Leave usage in the selected period by employee + type.
 * Entitlement uses employee.employeeAnnualLeaveDays when present; else blank.
 */
export const leaveBalance = (
  data,
  filter,
  columns,
  manualColumns,
  employees,
) => {
  if (!filter) return emptyReportResult(columns, manualColumns);

  const { startTs, endTs } = intervalBounds(filter);
  const requests = data || [];
  const empBySub = new Map((employees || []).map((e) => [e.userSub, e]));
  const empById = new Map((employees || []).map((e) => [e.employeeId, e]));

  const used = new Map(); // `${employeeId}|${type}` -> days

  for (const req of requests) {
    if (req?.requestStatus !== "Aprovuar") continue;
    const period = Array.isArray(req.requestPeriod) ? req.requestPeriod : [];
    const daysInRange = period.filter((p) => {
      const t = dayjsTZ(p).valueOf();
      return t >= startTs && t <= endTs;
    });
    if (!daysInRange.length) continue;

    const emp =
      req.employeeDetails ||
      empBySub.get(req.userSub) ||
      empById.get(req.employeeId) ||
      {};
    const empId = emp.employeeId || req.employeeId || req.userSub;
    if (filter?.employeeId && empId !== filter.employeeId) continue;

    const type = req.requestType || "Tjetër";
    const key = `${empId}|${type}`;
    if (!used.has(key)) {
      used.set(key, {
        employee: employeeFullName(emp) || `${req.given_name || ""} ${req.family_name || ""}`.trim(),
        employeeDepartmentName: emp.employeeDepartmentName || "",
        employeeTeam: emp.employeeTeam || "",
        requestType: type,
        entitledDays:
          Number(emp.employeeAnnualLeaveDays) ||
          Number(emp.annualLeaveDays) ||
          "",
        usedDays: 0,
        remainingDays: "",
      });
    }
    used.get(key).usedDays += daysInRange.length;
  }

  const preFilter = [...used.values()]
    .map((r) => {
      const entitled = r.entitledDays === "" ? null : Number(r.entitledDays);
      const remaining =
        entitled != null && LEAVE_TYPES.includes(r.requestType)
          ? Math.max(0, entitled - r.usedDays)
          : "";
      return {
        ...r,
        usedDays: r.usedDays,
        remainingDays: remaining === "" ? "" : remaining,
      };
    })
    .sort(
      (a, b) =>
        String(a.employee).localeCompare(String(b.employee), "sq") ||
        String(a.requestType).localeCompare(String(b.requestType), "sq"),
    );

  return buildReportResult(preFilter, columns, manualColumns);
};
